import { FILTER_PARAMS, QUERY_KEYS, useFilter } from '@monorepo/helpers';
import { useGetRequest } from '@monorepo/requests';
import { InfiniteData, useInfiniteQuery } from '@tanstack/react-query';
import {
  ListProductResponse,
  Product
} from '@spilca/dictionary_ts/v1/dictionary_md/product_pb';
import { TGRPCPromiseReject } from '@monorepo/grpc';
import get from 'lodash/get';

const useGetPackageIDs = ({
  pageSize,
  productId
}: {
  pageSize: number;
  productId: number;
}) => {
  const { filter } = useFilter();
  const typeRequest = 'product-package';

  const request = useGetRequest('GET_DICTIONARY_LIST_PRODUCT_PACKAGE');

  const response = useInfiniteQuery<
    ListProductResponse.AsObject,
    TGRPCPromiseReject
  >({
    queryKey: [
      `${QUERY_KEYS.DICTIONARIES_LIST}_${typeRequest}`,
      {
        pageSize,
        product_id: productId ? [productId] : [],
        ...filter
      }
    ],
    queryFn: ({ queryKey, pageParam }) => {
      const params = queryKey[1] as object;
      // @ts-ignore
      const currentPage = pageParam || params[FILTER_PARAMS.page || 1];
      // @ts-ignore
      return request({ ...params, currentPage });
    },

    initialPageParam: 1,
    gcTime: 30000,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    getNextPageParam: (lastPage, allPages) =>
      // @ts-ignore
      get(lastPage, 'pagination.totalPages') > allPages.length
        ? allPages.length + 1
        : undefined
  });

  const convertDataForGrid = (
    data: InfiniteData<ListProductResponse.AsObject> | undefined
  ): Array<any> => {
    if (!data) {
      return [];
    }

    return data.pages.reduce(
      (acc: Array<Product.AsObject>, page) =>
        page ? [...acc, ...page.itemsList] : acc,
      []
    );
  };

  return { ...response, convertDataForGrid };
};

export default useGetPackageIDs;
